// extracted by mini-css-extract-plugin
module.exports = {"form":"FormWrapper_form__2Q8pt"};